<template>
  <div class="flex flex-col justify-center h-full leading-tight">
    <span class="sensitive text-sm text-gray-900 truncate">{{ titleCase(primary) || '-' }}</span>
    <span v-if="secondary && secondary !== primary" class="sensitive text-xs text-gray-500 truncate">{{ titleCase(secondary) }}</span>
  </div>
</template>

<script>
const KEEP = new Set(['LLC','PLLC','PC','MD','DO','NP','PA','RN','DPM','OD','II','III','IV','JR','SR']);

export default {
  name: 'EntityCell',
  props: ['params'],
  computed: {
    primary() {
      return this.params.data?.practice_name;
    },
    secondary() {
      return this.params.data?.provider_name;
    }
  },
  methods: {
    titleCase(str) {
      if (!str) return str;
      return str.split(/\s+/).map(w => {
        if (KEEP.has(w.replace(/[,.]$/, '').toUpperCase())) return w.toUpperCase();
        return w.toLowerCase().replace(/^\w/, c => c.toUpperCase());
      }).join(' ');
    }
  }
};
</script>
